export interface Delivery {
    id?: number;
    sales_order_id?: number;
    society_id?: number;
    client_id?: number;
    delivery_date?: string;
    destination_id?: number;
    status?: string;
    is_inventory_processed?: boolean;
    observations?: string;
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
    // Campos del serializer All
    delivery_number?: string;
    sales_order?: string;
    society?: string;
    client_rut?: string;
    client?: string;
    destination?: string;
    status_display?: string;
    total_amount?: number;
    net_amount?: number;
}

export interface DeliveryDataForm {
    id?: number;
    sales_order_id?: number;
    society_id?: number;
    client_id?: number;
    delivery_date?: string;
    destination_id?: number;
    observations?: string;
    actual_delivery_date?: string | null;
    actual_delivery_registered_at?: string | null;
}

export const defaultDeliveryDataForm: DeliveryDataForm = {
    sales_order_id: undefined,
    society_id: undefined,
    client_id: undefined,
    delivery_date: undefined,
    destination_id: undefined,
    observations: ''
};

export interface DeliveryFilters {
    page: number;
    per_page: number;
    sort: string;
    order: string;
    id?: string;
    sales_order_id?: number;
    status?: string;
    is_inventory_processed?: string;
    delivery_date_from?: string;
    delivery_date_to?: string;
}

export interface DeliveryStatus {
    id: string;
    name: string;
    prev: string | null;
    next: string | null;
}

export interface DeliveryShow {
    id?: number;
    sales_order_id?: number;
    society_id?: number;
    client_id?: number;
    delivery_date?: string;
    destination_id?: number;
    status?: string;
    is_inventory_processed?: boolean;
    observations?: string;
    actual_delivery_date?: string | null;
    actual_delivery_registered_at?: string | null;
    is_active?: boolean;
    created_at?: string;
    updated_at?: string;
    // Campos del serializer Show (diferentes a All)
    sales_order?: {
        id: number;
        display: string;
    };
    society?: string;
    client?: string;
    destination?: string;
    status_display?: string;
    inventory_movement_id?: number;
    created_user?: {
        id: number;
        first_name: string;
        last_name: string;
        username: string;
    };
    updated_user?: {
        id: number;
        first_name: string;
        last_name: string;
        username: string;
    };
}
